/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Scope_Private_HintInputs */



/**
* | output |
* | --- |
* | "Only you can see and run this agent." |
*
* @param {Agent_Builder_Scope_Private_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_scope_private_hint = /** @type {((inputs?: Agent_Builder_Scope_Private_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Scope_Private_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Sie sehen und starten diesen Agenten.")
	return /** @type {LocalizedString} */ ("Only you can see and run this agent.")
});